// NOTE: content for UploadModals exported from src/utilities/usePrsUpload
// TODO: rename PrsUploadModalContent?
import { useEffect } from "react"
import { useParams } from "react-router-dom"
import "./PRSUpload.scss"
import { Form, Input } from "antd"

// Components
import { PrimeButton, ValidationMessage } from "components-design-system"
import Checkbox from "../Checkbox/Checkbox"
import PrimeNote from "components/PrimeNote/PrimeNote"

// api
import { useGetGlobalSiteSettings } from "api/hooks/admin/usePrsSiteMaskingApi"
import { useGetAuthoringStudy } from "api/hooks/studies/useAuthoringApi"
import { useGetStudy } from "api/hooks/studies/useStudiesApi"
import { PRS_UPLOAD_TASKS } from "../../constants/tasks"

const PRSUpload = ({ setOpenModal, onUploadToPRS, type, gridRef }) => {
  const { studyId } = useParams()
  const [form] = Form.useForm()
  const isPrsCredentialChecked = Form.useWatch("isPrsCredentialChecked", form)
  const { data: globalSettings } = useGetGlobalSiteSettings()
  const { data: study } = useGetStudy(studyId)
  const { data: authoring } = useGetAuthoringStudy(study?.authoring_study_id)
  const prsRecordStatus = authoring?.prs_record_status?.toLowerCase()

  useEffect(() => {
    if (globalSettings?.release_to_ctg) {
      form.setFieldsValue({ autorelease: true })
    } else {
      form.setFieldsValue({ autorelease: false })
    }
  }, [globalSettings, form])

  const renderWarning = () => {
    let approvalRequired = false
    const selectedNodes = gridRef?.current?.api?.getSelectedNodes()

    for (let i = 0; i < selectedNodes?.length; i++) {
      if (selectedNodes[i].data?.is_flagged) {
        approvalRequired = true
        break
      }
    }

    return (
      approvalRequired && (
        <div className="warning-message-container">
          <PrimeNote
            type="warning"
            msg="Data changes for the selected study(ies) require approval based on configured rules. Navigate to the Activities tab of a study to create a maintenance update activity."
          />
        </div>
      )
    )
  }

  return (
    <Form
      form={form}
      layout="vertical"
      onFinish={(values) => onUploadToPRS(values)}
      className="prs-upload"
      initialValues={{
        include_sites: false,
        autorelease: false,
        update_ver_date: false,
        isPrsCredentialChecked: false,
      }}
    >
      {renderWarning()}
      <Form.Item
        name="isPrsCredentialChecked"
        valuePropName="checked"
        style={{ marginBottom: 0 }}
        className="prs-upload-body"
      >
        <Checkbox>Submit using individual credentials</Checkbox>
      </Form.Item>
      {isPrsCredentialChecked && (
        <div className="prs-upload-individual-credentials-wrapper">
          <Form.Item
            label="Organization"
            name="organization"
            rules={[{ required: true }]}
            wrapperCol={{ span: 23 }}
          >
            <Input autoComplete="off" />
          </Form.Item>
          <Form.Item
            label="PRS username"
            name="username"
            rules={[{ required: true }]}
            wrapperCol={{ span: 23 }}
          >
            <Input autoComplete="off" />
          </Form.Item>
          <Form.Item
            label="PRS password"
            name="password"
            rules={[{ required: true }]}
            wrapperCol={{ span: 23 }}
          >
            <Input.Password autoComplete="new-password" />
          </Form.Item>
        </div>
      )}

      {type === PRS_UPLOAD_TASKS.prsProtocolSiteUpload && (
        <Form.Item
          name="include_sites"
          valuePropName="checked"
          style={{ marginTop: 0, marginBottom: 0 }}
        >
          <Checkbox>Submit sites only</Checkbox>
        </Form.Item>
      )}

      <Form.Item
        className="prs-upload-body"
        name="autorelease"
        valuePropName="checked"
        style={{ marginTop: 0, marginBottom: 0 }}
      >
        <Checkbox>Release record(s) to CTG</Checkbox>
      </Form.Item>

      <Form.Item
        name="update_ver_date"
        valuePropName="checked"
      >
        <Checkbox>Update the record verification date</Checkbox>
      </Form.Item>

      {prsRecordStatus === "released" && (
        <Form.Item
          valuePropName="checked"
          name={"agreeToSubmitPrsRecordStatusConfirmation"}
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Checkbox>
            {prsRecordStatus === "released" &&
              `This record has been Released (submitted) for PRS Review, but review has not yet started. Checking this box confirms you understand another submission will be made from Prime updating this record in PRS.`}
            {/* {prsRecordStatus === "prs review" &&
              `This record has been Released (submitted) for PRS Review, and review has started. Checking this box confirms you understand another submission will be made from Prime updating this record in PRS.`} */}
          </Checkbox>
        </Form.Item>
      )}

      {prsRecordStatus === "prs review" && (
        <ValidationMessage
          type="warning"
          value={
            "This record has been Released (submitted) for PRS Review, and review has started and Study is locked. Submission cannot be done until PRS review is completed."
          }
        />
      )}

      <div className="prs-upload-actions">
        <PrimeButton
          onClick={() => setOpenModal(false)}
          style={{ marginRight: 16 }}
        >
          Cancel
        </PrimeButton>
        <PrimeButton
          type="primary"
          disabled={prsRecordStatus === "prs review"}
          htmlType="submit"
        >
          Submit
        </PrimeButton>
      </div>
    </Form>
  )
}

export default PRSUpload
